import { IOrderItem } from '@/interfaces/IOrderItem';

export type TManualPrintGateState = 'unprinted' | 'reprint' | 'nothing';

export interface IManualPrintGate {
  state: TManualPrintGateState;
  /** Full eligible set — what a confirmed full reprint should print. */
  reprintItems: IOrderItem[];
}

/**
 * Manual-print reprint gate (pure): classifies an order for one document
 * kind given its already-eligible items (routing/label filtering is the
 * caller's job — see `getManualPrintGate` in use-printing.ts).
 *
 * - `unprinted`: any eligible item has unprinted units (missing counter = 0).
 * - `reprint`: nothing unprinted, but there are reprintable items.
 * - `nothing`: no eligible items at all.
 */
export function computeManualPrintGateState(params: {
  eligibleItems: IOrderItem[];
  printKey: 'printC' | 'printE';
}): IManualPrintGate {
  const { eligibleItems, printKey } = params;

  const hasUnprinted = eligibleItems.some(
    (item) => (item[printKey] ?? 0) < item.amount
  );
  if (hasUnprinted) {
    return { state: 'unprinted', reprintItems: eligibleItems };
  }

  if (eligibleItems.length > 0) {
    return { state: 'reprint', reprintItems: eligibleItems };
  }

  return { state: 'nothing', reprintItems: eligibleItems };
}
